export default __webpack_public_path__ + "static/media/Minicard_9s.e822f978.svg";